import * as React from 'react'
import {Skeleton, Stack, Table, TableBody, TableCell, TableRow, Box, Grid} from '@mui/material'

export default function AccSkeleton({repeat}) {
  return (
    <>
      {Array(repeat)
        .fill('')
        .map((k, i) => (
          <Stack
            key={i}
            direction={{xs: 'column', sm: 'row'}}
            spacing={{xs: 1, sm: 2, md: 4}}
            width='100%'
            height={60}
            sx={{
              backgroundColor: '#fff',
              marginTop: 2,
              marginBottom: 2,
              padding: 2,
              borderRadius: 1,
              border: '1px solid rgba(145, 158, 171, 0.24)',
            }}
            alignItems='center'
            justifyContent='center'
          >
            <Box width='10%'>
              <Skeleton width='100%' height='25px' />
            </Box>
            <Box width='19%'>
              <Skeleton width='100%' height='25px' />
            </Box>
            <Box width='19%'>
              <Skeleton width='100%' height='25px' />
            </Box>
            <Box width='19%'>
              <Skeleton width='100%' height='25px' />
            </Box>
            <Box width='19%'>
              <Skeleton width='100%' height='25px' />
            </Box>
            <Box width='10%' display='flex' alignItems='center' justifyContent='center'>
              <Skeleton width='100%' height='25px' />
            </Box>
          </Stack>
        ))}
    </>
  )
}

export function TableSkeleton({rows = 5, columns = 5, size = 'small', showHeader = true}) {
  const renderSkeletonContent = (index, isHeader = false) => {
    // Vary skeleton widths for more realistic appearance
    const widths = ['60%', '80%', '45%', '90%', '70%', '55%', '85%']
    const width = widths[index % widths.length]

    return (
      <Skeleton
        variant='text'
        width={width}
        height={isHeader ? 24 : 20}
        sx={{
          borderRadius: 1,
          backgroundColor: isHeader ? 'rgba(0, 0, 0, 0.08)' : 'rgba(0, 0, 0, 0.06)',
        }}
      />
    )
  }

  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        borderRadius: 1,
        border: '1px solid rgba(145, 158, 171, 0.24)',
        overflow: 'hidden',
      }}
    >
      <Table size={size}>
        {showHeader && (
          <TableBody>
            <TableRow
              sx={{
                backgroundColor: 'rgba(145, 158, 171, 0.08)',
                '& td': {
                  borderBottom: '1px solid rgba(145, 158, 171, 0.16)',
                  padding: size === 'small' ? '8px 16px' : '12px 16px',
                },
              }}
            >
              {Array(columns)
                .fill('')
                .map((_, j) => (
                  <TableCell key={`header-${j}`}>{renderSkeletonContent(j, true)}</TableCell>
                ))}
            </TableRow>
          </TableBody>
        )}
        <TableBody>
          {Array(rows)
            .fill('')
            .map((_, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(145, 158, 171, 0.04)',
                  },
                  '& td': {
                    borderBottom: i === rows - 1 ? 'none' : '1px solid rgba(145, 158, 171, 0.12)',
                    padding: size === 'small' ? '12px 16px' : '16px 16px',
                  },
                }}
              >
                {Array(columns)
                  .fill('')
                  .map((_, j) => (
                    <TableCell key={j}>{renderSkeletonContent(j + i)}</TableCell>
                  ))}
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </Box>
  )
}

export function FormSkeleton() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
    </Grid>
  )
}
export function CourierSkeleton() {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Skeleton variant='text' width={200} />
        <Skeleton variant='rectangular' width='100%' height={40} />
      </Grid>
    </Grid>
  )
}
